// src/utils/getImageUrl.js
export const getImageUrl = (imageUrl) => {
    // If no image URL provided, return null
    if (!imageUrl) {
      return null;
    }
    
    // If it's already a full URL (starts with http:// or https://), return as is
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
      return imageUrl;
    }
    
    // Otherwise, prepend the base URL
    const baseUrl = process.env.REACT_APP_API_URL || '';
    
    // Normalize the URL, ensuring not to duplicate slashes.
    if (imageUrl.startsWith("/")) {
      return `${baseUrl}${imageUrl}`;
    }
    
    return `${baseUrl}/${imageUrl}`;
  };